const ensureMarqueeCoverage = ({ marqueeSelector, trackSelector, groupSelector }) => {
  const setupMarquee = (marquee) => {
    const track = marquee.querySelector(trackSelector);
    if (!track) return;

    const groups = Array.from(track.querySelectorAll(groupSelector));
    if (groups.length === 0) return;

    const template = groups[0];
    for (let i = groups.length - 1; i > 0; i -= 1) {
      groups[i].remove();
    }

    const groupWidth = template.getBoundingClientRect().width;
    if (!groupWidth) return;

    const trackStyles = window.getComputedStyle(track);
    const gapValue = trackStyles.columnGap || trackStyles.gap || "0";
    const gap = Number.parseFloat(gapValue) || 0;
    const segment = groupWidth + gap;

    const marqueeWidth = marquee.getBoundingClientRect().width;
    let count = 2;
    while (segment * count < marqueeWidth + segment) {
      count += 1;
    }

    for (let i = 1; i < count; i += 1) {
      const clone = template.cloneNode(true);
      clone.setAttribute("aria-hidden", "true");
      track.appendChild(clone);
    }

    track.style.setProperty("--scroll-distance", `${segment}px`);

    const speedValue = window
      .getComputedStyle(marquee)
      .getPropertyValue("--scroll-speed")
      .trim();
    const speed = Number.parseFloat(speedValue) || 80;
    const duration = Math.max(segment / speed, 1);
    track.style.setProperty("--scroll-duration", `${duration}s`);
  };

  const refresh = () => {
    document.querySelectorAll(marqueeSelector).forEach(setupMarquee);
  };

  if (document.readyState === "complete") {
    requestAnimationFrame(refresh);
  } else {
    window.addEventListener("load", refresh, { once: true });
  }

  window.addEventListener("resize", () => requestAnimationFrame(refresh));

  if ("ResizeObserver" in window) {
    const observer = new ResizeObserver(() => requestAnimationFrame(refresh));
    document.querySelectorAll(marqueeSelector).forEach((marquee) => {
      observer.observe(marquee);
    });
  }
};

ensureMarqueeCoverage({
  marqueeSelector: ".customer-taxonomy-marquee",
  trackSelector: ".customer-taxonomy-track",
  groupSelector: ".customer-taxonomy-group",
});

ensureMarqueeCoverage({
  marqueeSelector: ".logos-marquee",
  trackSelector: ".logos-track",
  groupSelector: ".logos-group",
});

const enableMarqueeBrake = ({ marqueeSelector, trackSelector }) => {
  const rafByTrack = new WeakMap();
  const easeOutCubic = (t) => 1 - Math.pow(1 - t, 3);
  const ramp = (
    track,
    animation,
    targetRate,
    duration = 400,
    pauseOnEnd = false
  ) => {
    const existing = rafByTrack.get(track);
    if (existing) {
      cancelAnimationFrame(existing);
    }
    const start = animation.playbackRate || 1;
    if (start === targetRate) return;
    const startTime = performance.now();
    const step = (now) => {
      const progress = Math.min((now - startTime) / duration, 1);
      const eased = easeOutCubic(progress);
      animation.playbackRate = start + (targetRate - start) * eased;
      if (progress < 1) {
        const raf = requestAnimationFrame(step);
        rafByTrack.set(track, raf);
      } else if (pauseOnEnd) {
        animation.pause();
      }
    };
    const raf = requestAnimationFrame(step);
    rafByTrack.set(track, raf);
  };

  const getAnimation = (track) => {
    const animations = track.getAnimations();
    return animations.length ? animations[0] : null;
  };

  const attach = (marquee) => {
    if (!marquee.classList.contains("has-marquee-brake")) return;
    const track = marquee.querySelector(trackSelector);
    if (!track) return;

    const onEnter = () => {
      const animation = getAnimation(track);
      if (animation) {
        animation.play();
        ramp(track, animation, 0, 400, true);
      }
    };
    const onLeave = () => {
      const animation = getAnimation(track);
      if (animation) {
        animation.play();
        animation.playbackRate = Math.max(animation.playbackRate || 0, 0.0001);
        ramp(track, animation, 1);
      }
    };

    marquee.addEventListener("mouseenter", onEnter);
    marquee.addEventListener("mouseleave", onLeave);
    marquee.addEventListener("focusin", onEnter);
    marquee.addEventListener("focusout", onLeave);
  };

  const init = () => {
    document.querySelectorAll(marqueeSelector).forEach(attach);
  };

  if (document.readyState === "complete") {
    requestAnimationFrame(init);
  } else {
    window.addEventListener("load", init, { once: true });
  }
};

enableMarqueeBrake({
  marqueeSelector: ".customer-taxonomy-marquee",
  trackSelector: ".customer-taxonomy-track",
});

enableMarqueeBrake({
  marqueeSelector: ".logos-marquee",
  trackSelector: ".logos-track",
});
